import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { useParams } from "react-router-dom";
import { NSLoading } from "namirasoft-site-react";
import { useEffect } from "react";
import { PaymentRoutes } from "../PaymentRoutes";

export interface SalesItemViewPageProps extends NSARouterMakerResult, PaymentProps { }

function SalesItemViewPage(props: SalesItemViewPageProps)
{
    let { id } = useParams<{ id: string }>();

    useEffect(() =>
    {
        if (id)
            props.servers.payment.sales_item.Get(id).then(sales_item =>
            {
                props.url.redirect(PaymentRoutes.OfferList(sales_item.product_id, sales_item.slug, false, ""), {})
            })
        // eslint-disable-next-line
    }, [id]);

    return <NSLoading></NSLoading>;
}

export default SalesItemViewPage;